import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {StatusCodes} from 'http-status-codes';
import {Observable, throwError} from 'rxjs';
import {catchError, flatMap, tap} from 'rxjs/operators';
import {FusionAuthService} from '../services/fusion-auth';
import {StorageService} from '../services/general';
import {handleJWTRefresh} from "./common";

@Injectable({
  providedIn: 'root',
})
export class FusionAuthRefreshTokenInterceptorService implements HttpInterceptor {
  constructor(
    private router: Router,
    private storage: StorageService,
    private fusionAuthService: FusionAuthService,
  ) {
  }

  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.fusionAuthService.getToken();

    if (token !== undefined && token !== null && token !== '') {
      req = req.clone({
        setHeaders: {
          Authorization: 'JWT ' + token,
        },
      });
    }

    return next.handle(req).pipe(
      // @ts-ignore
      catchError(err => {
        if (err.status === StatusCodes.UNAUTHORIZED && this.router.url !== '/login' && this.fusionAuthService.getRefreshToken()) {
          return handleJWTRefresh(this.fusionAuthService, this.router, req, next);
        }

        this.router.navigateByUrl('/login').then();

        return throwError(err);
      }),
    );
  }
}
